/**
 * Slides component.
 * @module components/Frontpage/Slides
 */

import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { UniversalLink, Image } from '@plone/volto/components';
import { searchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';
import { FormattedMessage } from 'react-intl';
import { Carousel } from '../../';
import { Container } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { map } from 'lodash';

const booAutoplay = false;

const SLIDE_OPTIONS = {
    loop: true,
    autoplay: booAutoplay,
    dots: true,
    buttons: true,
    customClass: 'main-slider',
    stopOnMouseEnter: true
}

const ItemView = props => {
    const { item } = props

    const vocabularySubjects = 'plone.app.vocabularies.Keywords';
    const dispatch = useDispatch();
    const itemsSubjects = useSelector(
        (state) =>
            state.vocabularies[vocabularySubjects] && state.vocabularies[vocabularySubjects].items
                ? state.vocabularies[vocabularySubjects].items
                : [],
        shallowEqual,
    );
    const getSubject = function (subject) {
        if (!itemsSubjects) {
            return subject
        }
        for (let item of itemsSubjects) {
            if (item.value === subject) return item.label
        }
        return subject
    }

    return (
        <article className={"slideItem " + (item?.getRemoteUrl ? 'slideItem--hasLink' : 'slideItem--noLink')} key={item['@id']}>
            <Image
                item={item}
                className="slideItem__image"
                alt=""
                sizes="(max-width: 991px) 100vw, 50vw"
            />

            <div className="slideItem__text">
                {item?.Subject && (
                    <>
                        {map(item.Subject.slice(0, 1), (item, index) => (
                            <p className="text-overlay" key={item}>{getSubject(item)}</p>
                        ))}
                    </>
                )}

                {item?.getRemoteUrl ? (
                    <h3 className="slideItem__title mt-0 mb-4">
                        <UniversalLink href={item.getRemoteUrl} className="slideItem__link stretched-link">{item.title}</UniversalLink>
                    </h3>
                ) : (
                    <h3 className="slideItem__title mt-0 mb-4 ">{item.title}</h3>
                )}
                {item?.description ? (
                    <p className="slideItem__desc mb-4">
                        {item.description}
                    </p>
                ) : null}
                {item?.getRemoteUrl && (
                    <span className="button ui slideItem__btn">
                        {item?.button_text ? (
                            <>{item.button_text}</>
                        ) : (
                            <><FormattedMessage id="More info" defaultMessage="More info" /></>
                        )} 
                    </span>
                )}
            </div>
        </article>
    )

};

const SliderListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {
    let href = (linkHref?.[0]?.['@id']) || '';
    let link = href ? flattenToAppURL(href) : '';

    return (
        <section id="featuredSection" className={`slides slidesWrapper ${isEditMode ? 'container ui' : ' '} ${items.length > 1 ? 'slides--multiple' : 'slides--1item'}` } >
            <h2 className="visually-hidden"><FormattedMessage id="featured" defaultMessage="Featured" /></h2>
            {items && <Carousel slides={items.slice(0, 8)} delayTime={6500} ItemView={ItemView} options={SLIDE_OPTIONS} />}
        </section>
    );

};

export default SliderListing;
